document.addEventListener("DOMContentLoaded", function () {
  class FilterTag extends HTMLAnchorElement {
    #boundHandleRemove;
    constructor() {
      super();
      this.#boundHandleRemove = this.#handleRemove.bind(this);
      this.addEventListener("click", this.#boundHandleRemove);
    }
    #handleRemove(event) {
      event.preventDefault();
      const _params = this.#getValues(this.href);
      const _sourceParams = this.#getValues(document.location.href);
      for (const [key, value] of _params.entries()) {
        _sourceParams.delete(key, value);
      }
      window.location.search = _sourceParams.toString();
    }
    #getValues(url) {
      const parsedUrl = new URL(url);
      return parsedUrl.searchParams;
    }
  }
  customElements.define("filter-tag", FilterTag, {
    extends: "a"
  });
});